import { createFileRoute } from '@tanstack/react-router';
import { IconsPage } from '../features/icons/catalog-page';

/**
 * /icons — icon catalog Browse (was the old flat `/icons` route).
 *
 * Renders the full shipped `@osd/icons` catalog (see
 * `features/icons/catalog.ts` for the live `ICON_CATEGORIES` /
 * `TOTAL_ICONS`) with a search box (case-insensitive substring
 * filter across label + subpath + component name), anchor links per
 * category, and the hero / cookbook / tree-shaking sections. Wrapped
 * in `icons._layout` so the layout (Getting started / Browse entry
 * pair) is shared across the icon-kit pages.
 *
 * The actual JSX lives in `features/icons/catalog-page.tsx` so the
 * route file stays a one-liner re-export + the required
 * `createFileRoute` call (TanStack Router file-based routing requires
 * the Route declaration to live in the file matching the URL pattern).
 *
 * Per root/osd#80 (`@osd/icons` umbrella). `root/osd#81` is closed.
 */
export const Route = createFileRoute('/icons/_layout/')({
  component: IconsPage,
});
